var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mastered-game-icon"},[_c('img',{attrs:{"src":require('@/assets/games/mastered-game-icon.png'),"alt":""}}),_c('span',[_vm._v("Mastered")])])}
var staticRenderFns = []

export { render, staticRenderFns }